//import React, { useState } from "react";
import React, { useEffect, useState, useRef, useContext } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from "axios";

const ReactivateAccountModal = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [countdown, setCountdown] = useState(null);

    if (!isOpen) return null;

    const handleSubmit = async () => {

        setMessage("");

        if (!email) {
            setMessage("Please enter your email.");
            return;
        }

        // Basic email regex pattern 
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check invalid format 
        if (!emailPattern.test(email)) {
            setMessage("Please enter a valid email address.");
            return;
        }

        setMessage("");


        try {

            const config = {
                headers: {
                    Authorization: `${process.env.REACT_APP_CONFIGURE_HEADERS_AUTHORIZATION}`,
                },
                params: {
                    email: email
                }
            };

            axios
                .get(`api/UserProgram/ResendOktaActivationEmail`, config)
                .then((result) => {
                    //console.log("activation email re-sent", result.data);
                    setMessage("If the account exists, an activation email has been sent.");

                    // Start countdown at 5 seconds 
                    setCountdown(5);

                    // Update countdown every second 
                    const interval = setInterval(() => {
                        setCountdown((prev) => { if (prev === 1) { clearInterval(interval); } return prev - 1; });
                    }, 1000);

                    // Auto-close after 5 seconds 
                    setTimeout(() => {
                        onClose();
                        setMessage("");
                        setEmail("");
                        setCountdown(null);
                    }, 5000);

                })
                .catch((error) => {
                    setMessage("Unable to process request. Please try again.");
                });

        } catch (err) {
            console.error("Reactivate error:", err);
            setMessage("An error occurred. Please try again.");
        }

    };

    return (
        <Modal className="reactivate-account-modal" 
        show={isOpen} onHide={onClose} enforceFocus={false}
        backdrop="static">
            <Modal.Header>
                <h3>Account Reactivation</h3>
            </Modal.Header>
            <Modal.Body style={{ paddingTop: "10px", paddingBottom: "20px" }}>
                <p>Enter your email to receive the activation link.</p>

                <div className="reactivate-input-wrapper" style={{ padding: "10px" }}>
                    <input
                        type="email"
                        className={`form-control reactivate-input ${message ? "is-invalid" : ""}`}
                        placeholder="Email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleSubmit();
                            }
                        }}

                    />
                </div>

                <div className="mt-3">
                    <Button variant="primary" onClick={handleSubmit}>
                        Submit
                    </Button>

                    <Button variant="secondary" className="ml-2" onClick={onClose}>
                        Cancel
                    </Button>
                </div>

                {message && (
                    <p className="mt-3"
                        style={{
                            color: message.includes("activation email has been sent") ? "green" : "red"
                        }}
                    >{message}</p>
                )}

                {/* Countdown UI */}
                {countdown !== null && (
                    <p className="mt-2 text-muted">
                        This window will close in <strong>{countdown}</strong> seconds…
                    </p>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ReactivateAccountModal;
